Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    mediaQueries: []
  },
  mutations: {
    mediaQueries(state, params) {
      if (params.add && typeof params.add === "string" && !state.mediaQueries.includes(params.remove)) {
        state.mediaQueries.push(params.add);
      }
      if (params.remove && typeof params.remove === "string" && state.mediaQueries.includes(params.remove)) {
        state.mediaQueries.splice(state.mediaQueries.indexOf(params.remove), 1);
      }
    }
  }
})

export default store;